import React, { useEffect, Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Dialog, Transition } from "@headlessui/react";

import TopBar from "./TopBar";

import community from "../../assets/community.png";
import coin from "../../assets/coin.png";
import privacy from "../../assets/privacy.png";
import terms from "../../assets/terms.png";
import profile from "../../assets/profile_edit.png";

import { redeemBalance, isVerified } from "../../service/api";
import { FaSpinner  } from "react-icons/fa";

function CreatorProfile() {
  let [isOpen, setIsOpen] = useState(false);

  const [isLoading, setLoading] = useState(false);

  function openModal() {
    setIsOpen(true);
  }

  const navigate = useNavigate();

  const creator_data = JSON.parse(sessionStorage.getItem("creatordata"));
  useEffect(() => {
    if (!creator_data) navigate("/creator/login");
  });

  const CheckIsVerified = async () => {
    setLoading(true);

    var response = await isVerified(creator_data.email);
    if (response) {
      await redeemBalance({ email: creator_data.email });
      setLoading(false);
      openModal();
    } else {
      setLoading(false);

      navigate("/creator/bankdetails");
    }
  };

  return (
    <>
      <MyModal isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className="bg flex flex-col bg h-full min-h-screen">
        <TopBar />
        <div className="flex items-center justify-center font-semibold">
          <div className="flex flex-col items-center m-5 w-3/5">
            <div className="flex justify-between items-center text-xl w-full border-b-2 p-4 pt-0 border-gray-700">
              <div className="flex gap-3 items-center text-slate-100">
                <img
                  src={"" + creator_data.image}
                  alt="user"
                  className="rounded-full w-16 h-16"
                />
                  <div className="flex align-center justify-center">
                
                <div className="text-[#000] text-xl">{creator_data.email}</div>
                </div>
              </div>
            </div>
            {isLoading && (
              <center className="py-20 my-20">
                <FaSpinner icon="spinner" className="spinner" size={70} />
              </center>
            )}
            {!isLoading && (
              <div className="grid grid-cols-2 gap-5 p-5 w-full text-slate-100">
                <div
                  className="h-20 flex gap-3 bg-opacity-10 bg-black w-full items-center justify-center rounded-lg shadow cursor-pointer"
                  onClick={() => navigate("/terms")}
                >
                  <img src={terms} alt="terms" />
                  <div className="flex align-center justify-center">
                    <div className="text-[#000]">Terms & Conditions</div>
                  </div>
                </div>
                <div
                  className="h-20 flex gap-3 bg-opacity-10 bg-black w-full items-center justify-center rounded-lg shadow cursor-pointer"
                  onClick={() => navigate("/privacy")}
                >
                  <img src={privacy} alt="privacy" />
                  <div className="flex align-center justify-center">
                    <div className="text-[#000]">Privacy</div>
                  </div>
                </div>
                <div
                  className="h-20 flex gap-3 bg-opacity-10 bg-black w-full items-center justify-center rounded-lg shadow cursor-pointer"
                  onClick={() => navigate("/community")}
                >
                  <img src={community} alt="community" />

                  <div className="flex align-center justify-center">
                    <div className="text-[#000]">Community Guidelines</div>
                  </div>
                </div>
                <div
                  className="h-20 flex gap-3 bg-opacity-10 bg-black w-full items-center justify-center rounded-lg shadow cursor-pointer"
                  onClick={() => navigate("/creator/updateprofile")}
                >
                  <img src={profile} alt="profile" />

                  <div className="flex align-center justify-center">
                    <div className="text-[#000]">Update Profile</div>
                  </div>
                </div>
                <div
                  className="h-20 flex gap-3 bg-opacity-10 bg-black w-full items-center justify-center rounded-lg shadow cursor-pointer"
                  onClick={async () => {
                    CheckIsVerified();
                  }}
                >
                  <img src={coin} alt="coin" />
                  <div className="flex align-center justify-center">

                  <div className="text-[#000]">Redeem</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default CreatorProfile;

function MyModal({ isOpen, setIsOpen }) {
  function closeModal() {
    setIsOpen(false);
  }

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto"
          onClose={closeModal}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>

            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900"
                >
                  Success
                </Dialog.Title>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">Request Send</p>
                </div>

                <div className="mt-4 flex justify-end">
                  <button
                    type="button"
                    className="inline-flex justify-center items-end px-3 py-1.5 text-sm font-medium text-blue-900 bg-blue-100 border border-transparent rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                    onClick={closeModal}
                  >
                    OK
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
